import React from "react";
import "./Text.css";
const Text = ({ text, className = "", color = "var(--N100)" }) => {
  if (text === undefined || text === null || text === "") return null;
  return (
    <div
      className={`lead360Text ${className}`}
      title={text}
      style={{ color }}
      data-testid="lead360-text"
    >
      {text}
    </div>
  );
};

export default Text;
